import React from 'react';
import CopyIcon from '@atlaskit/icon/glyph/copy';
import { type Command, CommandActionType } from '@atlassian/jira-command-palette';
import {
	COMMAND_PALETTE_SECTIONS,
	COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY,
	useCommandKeywords,
} from '@atlassian/jira-command-palette-common';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { useFlagsService } from '@atlassian/jira-flags';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages';
import { getWindow, getNavigator } from './utils';

export const useCopyPageUrlCommand = (): Command => {
	const { showFlag } = useFlagsService();
	const { formatMessage } = useIntl();

	const copyToClipboard = async () => {
		try {
			await getNavigator().clipboard.writeText(getWindow().location.href);
			showFlag({
				type: 'success',
				title: messages.successTitleCopiedUrl,
			});
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (err: any) {
			showFlag({
				type: 'error',
				title: messages.errorTitleCopiedUrl,
				description: messages.errorDescriptionCopiedUrl,
			});

			fireErrorAnalytics({
				error: err,
				meta: {
					id: 'commandPaletteCopyUrlToClipboard',
					packageName: 'jiraCommandPaletteIntegration',
					teamName: 'deliveroo',
				},
			});
		}
	};

	const { getKeywords } = useCommandKeywords();

	return {
		id: 'copy-page-url',
		name: formatMessage(messages.commandCommandLabel),
		keywords: getKeywords('copyCurrentPageUrlSynonyms'),
		primaryAction: {
			type: CommandActionType.PERFORM,
			perform: copyToClipboard,
		},
		section: COMMAND_PALETTE_SECTIONS.quickActions,
		priority: COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY.copyUrl,
		components: {
			LeftIcon: () => <CopyIcon label={formatMessage(messages.commandCommandLabel)} />,
		},
		analytics: {
			action: 'copyPageURL',
		},
	};
};
